var MenuItem_module_default = {
	item: "_item_bym9p_8",
	interactive: "_interactive_bym9p_26",
	"no-label": "_no-label_bym9p_31",
	label: "_label_bym9p_35",
	"no-icon": "_no-icon_bym9p_42",
	icon: "_icon_bym9p_51",
	"nav-hint": "_nav-hint_bym9p_60",
	disabled: "_disabled_bym9p_140"
};
//#endregion
export { MenuItem_module_default as default };

//# sourceMappingURL=MenuItem.module.js.map